export default function CardValores({ title, description }) {
  return (
    <div className="w-max overflow-hidden relative border border-white rounded-[30px] bg-white/10 px-6 sm:px-10 md:px-12 pt-7 pb-9 min-h-[202px] flex items-center justify-center flex-col text-center space-y-5 hover:bg-white hover:text-black hover:shadow-2xl hover:shadow-white/40 transition-all duration-300 group">
      <div className="py-1 px-4 sm:px-7 bg-white text-black rounded-full w-fit mx-auto transition-all duration-300">
        <h3 className="font-inter-bold uppercase text-base group-hover:text-2xl transition-all duration-300">
          {title}
        </h3>
      </div>
      <p className="font-inter-light text-[18px] group-hover:text-xl break-words transition-all duration-300 text-wrap">
        {description}
      </p>
    </div>
  )
}
